<template>
  <div class="one-column-width">
    <!-- show action result -->
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ snackBarText }}</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <v-snackbar v-model="errorMessage" absolute top right color="danger">
      <span>Something went RONG, Please Try Again!</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">
              Do you really want to DELETE this item?
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">
              No
            </v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem">
              <b-spinner small type="grow" v-if="deleting"></b-spinner>
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- form start -->
    <v-card class="add-form-title" v-if="showFormData">
      <v-card-title>Build Admission Form</v-card-title>
      <div>
        <v-form
          ref="form"
          @submit.prevent="submit"
          class="custom-form"
          lazy-validation
        >
          <v-container fluid>
            <!-- /////////////////////////// -->
            <div class="col-md-12 row p-0 m-0">
              <div class="bg-white col-md-12 row p-0 m-0">
                <div class="col-md-12 py-0 row m-0 inputs_mange">
                  <div class="col-md-4 p-0">
                    <v-text-field
                      v-model="form_name"
                      label="Form Name"
                      class="border__input_ch r_formtabs_inputs _ch"
                    ></v-text-field>
                  </div>
                  <div
                    class="row col-md-12 p-0 m-0"
                    :style="
                      index == 0 ? 'margin-top: 0%; ' : 'margin-top: 1%; '
                    "
                    v-for="(item, index) in qa"
                    :key="index"
                  >
                    <div class="col-md-4 p-0">
                      <v-text-field
                        v-model="item.question"
                        label="Enter Field Label"
                        class="border__input_ch r_formtabs_inputs _ch"
                      ></v-text-field>
                    </div>

                    <div
                      class="col-md-4 pl-0 border__input_ch__ mt-2 pt-0 pb-0 pl-4"
                    >
                      <b-form-select
                        v-model="item.type"
                        :options="qaTypes"
                        size="sm"
                        class="mt-0 border__input_ch r_formtabs_inputs _ch"
                      ></b-form-select>
                    </div>
                    <div class="col-md-3 p-0" style="margin-top: 0%;">
                      <div
                        class="col-md-12 p-0"
                        style="display: flex;margin-top: 0.5%;margin-left: 0%;"
                      >
                        <v-btn
                          class="custom-add-new-record-button btn_row_ch"
                          type="button"
                          fab
                          small
                          @click="addNewQuestionRow"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button btn_row_ch"
                          type="button"
                          fab
                          small
                          @click="removeQuestionRow(index)"
                        >
                          Del
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ////////////////////////// -->
            <!-- <v-col
              cols="12"
              sm="12"
              v-for="(tab, index1) in formFields"
              :key="index1"
            >
              <h1>TAB: {{ tab.name }}</h1>
              <v-row
                v-for="(item, index) in tab.fields"
                :key="index"
                cols="12"
                sm="12"
                style="border: 1px solid;"
              >
                <v-text-field
                  v-model="item.sequence"
                  :rules="rules.sequence"
                  color="purple name-2"
                  label="sequence"
                  class="col-md-3"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.caption"
                  :rules="rules.caption"
                  color="purple name-2"
                  label="Caption"
                  class="col-md-3"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.label"
                  :rules="rules.label"
                  color="purple name-2"
                  label="Field Label"
                  class="col-md-3"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="item.length"
                  :rules="rules.length"
                  color="purple name-2"
                  label="length"
                  class="col-md-2"
                  required
                ></v-text-field>
                <v-radio-group
                  v-model="item.editable"
                  row
                  class="col-md-3"
                  required
                >
                  <v-radio label="Show" value="1"></v-radio>
                  <v-radio label="Hide" value="0"></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="item.frontend"
                  row
                  class="col-md-3"
                  required
                >
                  <v-radio label="Optional " value="0"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col> -->
          </v-container>
          <v-card-actions class="pl-4 ml-4">
            <v-btn
              :disabled="submitting"
              class="custom-submit-button"
              type="submit"
            >
              <b-spinner small type="grow" v-if="submitting"></b-spinner>
              <span v-if="!editId">Submit</span>
              <span v-if="editId">Update</span>
            </v-btn>
            <v-btn text @click="cancelForm" onclick="reset()" class="custom-cancel-button">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
    <!-- form end -->

    <!-- table start -->
    <v-card>
      <v-card-title>
        Admission Form Tab Fields
        <div class="my-2 ml-2">
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showForm"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search fields"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="tableData" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <!-- <div>{{item.form_name}}</div> -->
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showEditForm(item)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          &nbsp;
          <!-- <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="previewForm(item)"
          >
            <v-icon dark>mdi-eye</v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- table end -->
  </div>
</template>

<script>
import AdmissionForm from '@/MainServices/AdmissionForm.js';
import { required, minLength } from 'vuelidate/lib/validators';
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formFields: [],
      token: `Bearer ${localStorage.getItem("token")}`,
      editId: null,
      deleteId: null,
      dialog: false,
      form_name: '',
      rules: {
        sequence: [(val) => !!val || 'Sequence is required'],
        caption: [(val) => !!val || 'Caption is required'],
        label: [(val) => !!val || 'label is required'],
        length: [(val) => !!val || 'length is required'],
        frontend: [
          (val) => (val || '').length > 0 || 'This Option is required',
        ],
        editable: [
          (val) => (val || '').length > 0 || 'This Option is required',
        ],
      },
      qa: [{ question: '', type: null }],
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: '',
      showFormData: false,
      valid: true,
      headers: [
        {
          text: 'Form Name',
          align: 'left',
          sortable: false,
          value: 'form_name',
          width: '30%',
        },
        {
          text: 'Form Fields',
          align: 'left',
          sortable: false,
          value: 'form_json',
          width: '50%',
        },

        { text: 'Actions', value: 'actions', sortable: false },
      ],
      tableData: [],
      tabsData: [],
      qaTypes: [
        { value: null, text: 'Select Field Type' },
        { value: 'text', text: 'text' },
        { value: 'email', text: 'email' },
        { value: 'textarea', text: 'textarea' },
        { value: 'integer', text: 'integer' },
      ],
    }
  },
  validations: {
    formFields: {
      required,
      $each: {
        caption: { minLength: minLength(1), required },
        label: { minLength: minLength(1), required },
        sequence: { minLength: minLength(1), required },
        length: { minLength: minLength(1), required },
        frontend: { minLength: minLength(1), required },
        editable: { minLength: minLength(1), required },
      },
    },
  },
  components: {},

  computed: {},

  methods: {
    getInititalData() {
      AdmissionForm.getInstituteTemplates()
        .then((res) => {
          res.data.map((el) => {
            el.form_json = JSON.parse(el.form_json);
            let names = el.form_json.map(x => x.question).join(", ");
            el.form_json = names;
          })
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false
        })
    },
    // main methods
    showForm() {
      this.editId = null
      this.showFormData = true
      this.resetForm()
    },
    previewForm(item) {
      localStorage.setItem('preview_form_id', item.id)
      let routeData = this.$router.resolve({ name: 'PreviewAdmissionForm' })
      window.open(routeData.href, '_blank')
    },
    addNewQuestionRow() {
      this.qa.push({ question: '', type: null })
    },
    removeQuestionRow(index) {
      var temp = []
      this.qa.forEach((element, i) => {
        if (i !== index) temp.push(element)
      })
      this.qa = temp
    },
    showEditForm(item) {
      item.institute_form_tabs.map((tabs) => {
        let store_local = {
          id: tabs.id,
          name: tabs.name,
          sequence: tabs.sequence,
          fields: [],
        }
        tabs.fields.map((el2) => {
          store_local.fields.push({
            id: el2.id,
            caption: el2.caption,
            label: el2.label,
            sequence: el2.sequence,
            length: el2.length,
            type: el2.type,
            frontend: el2.frontend,
            editable: el2.editable,
          })
        })
        this.formFields.push(store_local)
      })
      this.editId = item.id
      this.showFormData = true
    },
    cancelForm() {
      this.resetForm()

      this.showFormData = false
    },
    resetForm() {
      this.form_name = null ;
      this.form = [
        {
          tab_id: null,
          caption: '',
          label: '',
          sequence: '',
          length: null,
          type: '',
          frontend: null,
          editable: null,
        },
      ]
      this.editId = null
      setTimeout(() => {
        this.$refs.form.reset()
      }, 100)
    },
    reset(){
      this.qa = [{ question: '', type: null }];
    },
    submit() {
      var user = JSON.parse(localStorage.getItem('user'));
      AdmissionForm.form_tamplates({
          user_id: user.id,
          form_name: this.form_name,
          form_json: this.qa,
         })
        .then((res) => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Form Successfuly build",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          })
          this.qa = [{ question: '', type: null }];
          this.cancelForm();
          this.getInititalData();
          // .then(function () {
          //   this.qa = [{ question: '', type: null }];
          //   this.resetForm()
          //   this.showFormData = false
          //   // window.location = "/recruiter/jobs";
          // });
        })
      // if (this.editId && this.$refs.form.validate()) {
      //   let fields = []
      //   this.formFields.map((el) => {
      //     el.fields.map((el2) => {
      //       fields.push(el2)
      //     })
      //   })
      //   this.submitting = true
      //   AdmissionForm.updateInstituteFormFields(fields)
      //     .then((res) => {
      //       this.showFormData = false
      //       this.getInititalData()
      //       this.submitting = false
      //       this.snackBarText = 'Fields Updated successful!'
      //       this.snackbar = true
      //     })
      //     .catch((error) => {
      //       this.errorMessage = true
      //     })
      // }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id
      this.dialog = true
    },
    deleteItem() {
      this.deleting = true
      AdmissionForm.deleteField(this.deleteId)
        .then((res) => {
          this.editId = null
          this.deleting = false
          this.dialog = false
          this.resetForm()
          this.getInititalData()
          this.snackBarText = 'Field Deleted successful!'
          this.snackbar = true
        })
        .catch((error) => {
          this.errorMessage = true
          this.dialog = false
        })
    },
  },
  mounted() {
    this.getInititalData()
    AdmissionForm.getFormTabs()
      .then((res) => {
        res.data.map((el) => {
          this.tabsData.push({ value: el.id, text: el.name })
        })
      })
      .catch((e) => {})
  },
}
</script>

<style>
.v-input {
  max-width: 25% !important;
}
</style>
